module.exports = __webpack_public_path__ + "img/aa.79a88647.jpg";